<template>
  <main class="page-main">
    <div class="uk-grid" data-uk-grid>
      <!-- 左侧主要内容 -->
      <div class="uk-width-2-3@l">
        <div class="widjet --filters">
          <div class="widjet__body">
            <div class="guide-section">
              <img src="@/assets/img/1726677766.png" alt="Header Image" class="header-img" />

              <!-- 方式一 -->
              <div class="section">
                <h1 class="section-title">
                  <span class="red-text">方式一</span>
                  <span class="blue-text">. 登录官网点 续费订阅 购买</span>
                </h1>
                <p class="step">1. 没有账号的先注册登录</p>

                <!-- 官网链接 -->
                <div class="links">
                  <p><strong>官网①：</strong>
                    <a href="https://ok.realsulian.com/" target="_blank" class="link-btn">访问官网</a>
                  </p>
                  <p><strong>备用官网②：</strong>
                    <a href="https://ok.goodsulian.com/" target="_blank" class="link-btn">点我查看</a>
                  </p>
                </div>

                <!-- 购买说明 -->
                <p class="info-text">个人版适合网页浏览多用户</p>
                <p class="info-text">专业版流量更多速度更快更稳，适合视频浏览多用户</p>

                <img src="@/assets/img/官网续费.jpg" alt="官网续费" class="guide-img" />

                <p class="info-text">2. 购买后直接使用，若不能使用可稍等片刻或点一键订阅重新导入URL订阅即可。</p>
              </div>

              <!-- 方式二 -->
              <div class="section">
                <h1 class="section-title">
                  <span class="red-text">方式二</span>
                  <span class="blue-text">. 速联软件内 点商店或续费-&gt;购买即可</span>
                </h1>

                <p class="platform-title">安卓</p>
                <img src="@/assets/img/安卓续费流程.jpg" alt="安卓续费流程" class="guide-img" />

                <p class="platform-title">Windows/Mac</p>
                <img src="@/assets/img/windonw续费流程1.png" alt="Windows续费1" class="guide-img" />
                <img src="@/assets/img/window续费流程2.png" alt="Windows续费2" class="guide-img" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧附加内容 -->
      <div class="uk-width-1-3@l">
        <div class="widjet --support">
          <div class="widjet__head">
            <h3 class="uk-text-lead">Need Help?</h3>
          </div>
          <div class="widjet__body">
            <p class="support-text">不懂的联系右下角的客服咨询</p>
            <img src="@/assets/img/lianxiwomen.jpg" alt="联系客服" class="guide-img" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "SubscriptionGuide",
};
</script>

<style scoped>
/* 🌟 让页面整体布局更协调 */
.page-main {
  width: 100%;
  padding: 20px;
  background: #f9f9f9;
}

/* 🌟 样式适配 uk-grid */
.uk-grid {
  display: flex;
  gap: 20px;
}

/* 🌟 主要内容区 */
.widjet {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.widjet__head h3 {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

/* 🌟 头部图片 */
.header-img {
  width: 100%;
  height: auto;
  border-radius: 10px;
  margin-bottom: 20px;
}

/* 🌟 标题样式 */
.section {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #ddd;
}

.section-title {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

.red-text {
  color: rgb(192, 0, 0);
}

.blue-text {
  color: rgb(54, 113, 185);
}

/* 🌟 文字内容 */
.step {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.info-text {
  font-size: 16px;
  color: #555;
  margin: 5px 0;
}

/* 🌟 平台标题 */
.platform-title {
  font-size: 20px;
  font-weight: bold;
  color: rgb(54, 113, 185);
  margin-top: 20px;
}

/* 🌟 购买链接按钮 */
.link-btn {
  display: inline-block;
  padding: 8px 15px;
  font-size: 16px;
  font-weight: bold;
  color: white;
  background-color: rgb(0, 112, 192);
  text-decoration: none;
  border-radius: 5px;
  transition: background 0.3s;
}

.link-btn:hover {
  background-color: rgb(0, 85, 150);
}

/* 🌟 图片样式 */
.guide-img {
  width: 100%;
  max-width: 900px;
  height: auto;
  margin: 15px 0;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

/* 🌟 联系客服区域 */
.support-text {
  font-size: 18px;
  font-weight: bold;
  color: rgb(192, 0, 0);
  margin-bottom: 10px;
}

/* 🌟 自适应布局 */
@media (max-width: 768px) {
  .uk-grid {
    flex-direction: column;
  }

  @media (max-width: 768px) {
  .uk-grid {
    flex-direction: column;
  }

  .widjet {
    width: 100%;
  }
}

  .widjet {
    padding: 15px;
  }

  .section-title {
    font-size: 20px;
  }

  .platform-title {
    font-size: 18px;
  }

  .link-btn {
    font-size: 14px;
    padding: 6px 12px;
  }
}
</style>
